module.exports = __webpack_public_path__ + "static/media/resina.ce602705.png";